import React from "react";
import Link from "gatsby-link";
import NextPageSection from "../NextPageSection";
import styled from "styled-components";

const SplitImageBottom = ({ img, blurb, link, linkText }) => {
  const Main = styled.div`
    background-image: url("${img.resolutions.src}");
    display: flex;
    justify-content: center;
    align-items: flex-end;
    position: relative;
    width: 100%;
    background-position: center top;
    background-size: cover;
    text-align: center;
    transition-duration: 0s;
    padding-top: ${img.resolutions.height / 1920 * 100 - 0.1}%;
    box-shadow: inset 0 10px 2px -4px rgba(0, 0, 0, 0.4);

    /* @media (max-width: 1029px) {
      background-position: inherit;
      background-position: center bottom;
    } */
    @media (max-width: 768px) {
      background-size: 200%;
      /* background-position: center -390px; */
      /* padding-top: 70%; */
    }
  `;

  const Next = styled(NextPageSection)`
    position: absolute;
    bottom: 0;
    margin-bottom: 6vw;

    @media (max-width: 768px) {
      position: relative;
      bottom: 40px;
      margin-bottom: unset !important;
    }
  `
  return (
    <Main className="container">
      <Next blurb={blurb} to={link} linkText={linkText} />
    </Main>
  );
};

export default SplitImageBottom;



// WEBPACK FOOTER //
// ./src/components/SplitImageBottom/index.js